"use client";

import { useEffect } from "react";
import { reportError } from "@/lib/bug-reporter";

export default function ErrorBoundary({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, { boundary: "error" });
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fafafa] p-6">
      <div className="text-center max-w-[400px]">
        <div className="text-[48px] mb-4">⚠️</div>
        <h1 className="font-serif text-[20px] font-bold text-[#111111] mb-2">
          Une erreur inattendue s&apos;est produite
        </h1>
        <p className="font-mono text-[12px] text-[#666666] mb-6">
          Nous sommes désolés pour la gêne occasionnée.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="bg-[#111111] text-white border-none rounded-[4px] py-3 px-6 font-mono text-[12px] font-bold cursor-pointer"
          >
            Recharger la page
          </button>
          <button
            type="button"
            onClick={reset}
            className="bg-white text-[#111111] border border-[#e0e0e0] rounded-[4px] py-3 px-6 font-mono text-[12px] font-bold cursor-pointer"
          >
            Réessayer
          </button>
        </div>
      </div>
    </div>
  );
}
